
import "./donationHeader.css";

export function DonationHeader() {
    return (
        <div className="donationHeaderContainer">
            <h1>Donation</h1>
        </div>
    );
}